export { i as instantiateRecord, m as modelFor, t as teardownRecord } from "./hooks-CNY5g4Ab.js";
export { b as buildSchema } from "./schema-provider-Bvogtzx9.js";